const RENTS_PENDING = 'rents_pending';
const RENTS_FAILED = 'rents_failed';
const RENTS_DOWNLOADED = 'rents_downloaded';
const RENTS_CSV_DOWNLOADED = 'rents_csv_downloaded';
const RENTS_RESET = 'rents_reset';
const RENT_SENDING = 'rent_sending';
const RENT_DOWNLOADED = 'rent_downloaded';
const RENTS_CLIENT_DOWNLOADED = 'rents_client_downloaded';
const RENTS_CSV_PENDING = 'rents_csv_pending';

export {
  RENTS_PENDING,
  RENTS_FAILED,
  RENTS_DOWNLOADED,
  RENTS_CSV_DOWNLOADED,
  RENTS_RESET,
  RENT_SENDING,
  RENT_DOWNLOADED,
  RENTS_CLIENT_DOWNLOADED,
  RENTS_CSV_PENDING,
};



// WEBPACK FOOTER //
// ./src/store/rents/types.js